/* eslint-disable no-control-regex */

export const inputMaskingConfiguration = {
  default: {
    get: (modelValue?: string | number) => modelValue,
    set: (value?: string | number) => value
  },
  npwp: {
    get: (modelValue?: string | number) => {
      const masked = modelValue
        ?.toString()
        .replace(
          /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,1})(\d{0,3})(\d{0,4})$/,
          (_match, p1, p2, p3, p4, p5, p6) => {
            let result = p1
            if (p2) result += '.' + p2
            if (p3) result += '.' + p3
            if (p4) result += '.' + p4
            if (p5) result += '-' + p5
            if (p6) result += '.' + p6
            return result
          }
        )

      return masked
    },
    set: (value?: string | number) => value?.toString().replace(/\D/g, '')
  },
  numbering: {
    get: (modelValue?: string | number) =>
      modelValue ? Number(modelValue).toLocaleString('id-ID') : undefined,
    set: (value?: string | number) =>
      value ? Number(value.toString().replace(/\D/g, '')) : undefined
  }
}

export const emojiRegex = /[^\x00-\x7F]+/gu
